export const paper = {
  rounded: {
    borderRadius: '8px',
  },
};

export default paper;
